import {ESortingActions} from 'modules/products/providers/CatalogPageProvider/types';
import {useRouter} from 'next/router';
import qs from 'qs';

export const useReviewsSearchParams = () => {
    const {query} = useRouter();
    const filter = query.filter as string | undefined;
    const sort = (query.sort as string) || ESortingActions.POPULAR;
    const parsed = filter ? qs.parse(filter) : {};
    const rating = 'string' === typeof parsed.rating ? parsed.rating : '';

    return {rating, sort};
};
